var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIApproved = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -25.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 25.058)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.05 25.058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27.325,11.913l-2.594-2.594.707-.707,1.887,1.887,5.246-5.246.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.985,15.254H-31.117a2.191,2.191,0,0,1-2.188-2.189V2.934A2.19,2.19,0,0,1-31.117.746h10.132A2.191,2.191,0,0,1-18.8,2.934V13.065A2.192,2.192,0,0,1-20.985,15.254ZM-31.117,1.746a1.189,1.189,0,0,0-1.188,1.188V13.065a1.19,1.19,0,0,0,1.188,1.189h10.132A1.19,1.19,0,0,0-19.8,13.065V2.934a1.19,1.19,0,0,0-1.189-1.188Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIApproved, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_approved.0025d677.svg";
export { ForwardRef as ReactComponent };